import { render, staticRenderFns } from "./autocomplete-text-field.vue?vue&type=template&id=80b42428&"
import script from "./autocomplete-text-field.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-text-field.vue?vue&type=script&lang=ts&"
import style0 from "./autocomplete-text-field.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
